// Campo de cupom no cart drawer. Usa a Ajax Cart API (/cart/update.js com "discount")
// e o mesmo fluxo de re-render do tema (sections + pubsub cartUpdate).
if (!customElements.get('cart-coupon')) {
  class CartCoupon extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-coupon-form]');
      this.removeButton = this.querySelector('[data-coupon-remove]');
      this.errorElement = this.querySelector('[data-coupon-error]');

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      if (this.removeButton) this.removeButton.addEventListener('click', this.onRemove.bind(this));
    }

    getSections() {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
      return sections;
    }

    update(discount, withSections) {
      const payload = withSections ? { discount, sections: this.getSections() } : { discount };
      return fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), body: JSON.stringify(payload) })
        .then((response) => response.json());
    }

    publish(cart) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-coupon', cart });
    }

    setLoading(isLoading) {
      this.toggleAttribute('aria-busy', isLoading);
      this.querySelectorAll('button, input').forEach((element) => { element.disabled = isLoading; });
    }

    showError(message) {
      if (!this.errorElement) return;
      this.errorElement.textContent = message;
      this.errorElement.hidden = !message;
    }

    async onSubmit(event) {
      event.preventDefault();
      const code = this.form.elements.discount.value.trim();
      if (!code) {
        this.showError('Digite o código do cupom.');
        return;
      }

      this.showError('');
      this.setLoading(true);

      try {
        const cart = await this.update(code, true);
        const match = (cart.discount_codes || []).find((item) => item.code.toLowerCase() === code.toLowerCase());

        if (match && match.applicable) {
          this.publish(cart);
          this.setLoading(false);
          return;
        }

        await this.update('', false);
        this.setLoading(false);
        this.showError(`O cupom "${code}" não é válido ou não se aplica a este carrinho.`);
      } catch (error) {
        this.setLoading(false);
        this.showError('Não foi possível aplicar o cupom. Tente novamente.');
      }
    }

    async onRemove() {
      this.setLoading(true);
      try {
        this.publish(await this.update('', true));
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define('cart-coupon', CartCoupon);
}
